import Carousel from "components/BaseWidgets/carousel";
import Avatar from "components/BaseWidgets/Avatar";
import Button from "components/BaseWidgets/button";
import { ArrowLeftIcon, ArrowRightIcon } from "assets/icons";
import "./style.scss";
import React from "react";
import defaultImage from 'assets/images/png/default-user.png'

function BlogBannerCard({ slides = [], slideInterval = 5000 }) {
  const carouselRef = React.useRef(null);

  const renderItem = (slide, index) => (
    <div className="banner-card" key={index}>
      <div className="banner-image">
        <img
          className="blog-banner-pic active"
          src={slide.bannerImage ? slide.bannerImage : defaultImage}
          alt={`${slide.blogCardHead}-img`}
        />
      </div>
      <div className="banner-content">
        <div className="banner-text-area">
          <h2 className="profile-card-head font-title-xxl fw-700">
            {slide.blogCardHead}
          </h2>
          <p className="profile-card-content font-title-xs fw-400">
            {slide.blogCardContent}
          </p>
        </div>
        <div className="user-info-row">
          <div className="user-info">
            <Avatar url={slide.userImage} />
            <div className="quoted-by">
              <p className="user-name font-title-xs">{slide.quotedName}</p>
              <span className="user-time font-body-normal fw-400">
                {slide.quotedTime}
              </span>
            </div>
          </div>
          <div className="arrows">
            <Button
              variant="round"
              className="arrow-left"
              onClick={() => carouselRef.current?.prev()}
            >
              <ArrowLeftIcon />
            </Button>
            <Button
              variant="round"
              className="arrow-right"
              onClick={() => carouselRef.current?.next()}
            >
              <ArrowRightIcon />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <Carousel
      ref={carouselRef}
      slides={slides}
      renderItem={renderItem}
      arrows={false}
      infinite={true}
      slidesToShow={1}
      slidesToScroll={1}
      draggable={false}
      className="blog-banner-carousel"
      settings={{
        autoplay: true,
        autoplaySpeed: slideInterval,
        fade: true,
      }}
    />
  );
}

export default BlogBannerCard;
